import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Box, Checkbox, FormControlLabel, IconButton, Tooltip } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import Bambora, { CreditCardField, CvvField, ExpiryField, Name, Submit } from 'bambora-material-ui'
import React from 'react'

const styles = () => ({
    hidden: {
        display: 'none',
    },
    saveCard: {
        flexBasis: '100%',
        padding: 4,
        marginRight: 0,
    },
    saveCardInfo: {
        padding: 8,
    },
})

class BamboraFrame extends React.Component {
    state = {
        paymentSaveCard: this.props.paymentSaveCard,
    }

    handlePaymentSaveChange = () => {
        const { paymentSaveCard } = this.state

        this.setState({
            paymentSaveCard: !paymentSaveCard,
        })
    }

    handleTokenEvent = async ({ token, expiryMonth, expiryYear, last4 }) => {
        const { paymentSaveCard } = this.state

        this.props.onTokenize(token, `${expiryMonth}${expiryYear}`, last4, null, null, paymentSaveCard)
    }

    render() {
        const { classes, className, forceSaveCard, saveCardLabel } = this.props
        const { paymentSaveCard } = this.state

        return (
            <Box className={className}>
                <Bambora onTokenization={this.handleTokenEvent}>
                    <Box className={classes.hidden}>
                        <Name label="Name on card" value="n/a" />
                    </Box>
                    <CreditCardField label="Credit card number" />
                    <ExpiryField label="Expiry" />
                    <CvvField label="CVV" />
                    <Tooltip disableInteractive arrow title="Cards are securely stored as encrypted tokens. Your actual card number is never saved.">
                        <FormControlLabel
                            className={classes.saveCard}
                            disabled={forceSaveCard}
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={paymentSaveCard}
                                    onClick={this.handlePaymentSaveChange}
                                />
                            }
                            label={saveCardLabel || 'Save card on file (secure)'}
                        />
                    </Tooltip>
                    <Tooltip disableInteractive arrow title="Cards are securely stored as encrypted tokens. Your actual card number is never saved." enterTouchDelay={0} leaveTouchDelay={10000}>
                        <IconButton className={classes.saveCardInfo} size="large">
                            <HelpOutlineIcon />
                        </IconButton>
                    </Tooltip><br />
                    <Submit label="Validate Card Info" size="medium" />
                </Bambora>
            </Box>
        )
    }
}

export default withStyles(styles, { withTheme: true })(BamboraFrame)
